import { Component } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { GlobalMessageService, UserAddressService, } from '@spartacus/core'
import { MbCheckoutStepService } from '../../../services/mb-checkout-step.service'
import { MbCheckoutCommonService } from '../../../services/mb-checkout-common.service'
import { MbCheckoutDeliveryFacade } from '../../../facades/mb-checkout-delivery.facade'
import { MbCheckoutShippingAddressBase } from '../mb-checkout-shipping-address-base'
import { MbCheckoutShippingFacade } from '../../../facades/mb-checkout-shipping.facade'
import { MbCheckoutRegions } from '../../../../models'
import { ActiveCartFacade } from '@spartacus/cart/base/root'

@Component({
  selector: 'mb-checkout-shipping-address-au',
  templateUrl: './mb-checkout-shipping-address-au.component.html',
  styleUrls: ['../mb-checkout-shipping-address-base.scss'],
})
export class MbCheckoutShippingAddressAuComponent extends MbCheckoutShippingAddressBase {

  checkoutRegion = MbCheckoutRegions.AU

  constructor (protected activatedRoute: ActivatedRoute,
               protected activeCartService: ActiveCartFacade,
               protected userAddressService: UserAddressService,
               protected mbCheckoutStepService: MbCheckoutStepService,
               protected mbCheckoutCommonService: MbCheckoutCommonService,
               protected mbCheckoutShippingFacade: MbCheckoutShippingFacade,
               protected globalMessageService: GlobalMessageService,
               protected mbCheckoutDeliveryService: MbCheckoutDeliveryFacade) {
    super(activatedRoute, activeCartService, userAddressService, mbCheckoutStepService, mbCheckoutCommonService, mbCheckoutShippingFacade,
      globalMessageService, mbCheckoutDeliveryService)
    this.mbCheckoutShippingFacade.cancelAddNewAddressForm()
  }
}
